const trustPoints = [
  'Detaylı yüzey temizliği',
  'Cam ve pencere alanları',
  'Zemin temizliği',
  'İnce inşaat tozu',
  'Mutfak ve yaşam alanları',
  'Profesyonel ekipman',
];

const whatsappUrl = 'https://wa.me/905077089198?text=Merhaba%2C%20in%C5%9Faat%20sonras%C4%B1%20temizlik%20i%C3%A7in%20teklif%20almak%20istiyorum.%20Alan%C4%B1n%20videosunu%20g%C3%B6ndermek%20istiyorum.';

export default function PostConstruction() {
  return (
    <section className="relative py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/3319ad2a74b6816d24d942d6d5219f28.png"
          alt="İnşaat sonrası profesyonel temizlik"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-navy-dark/85"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
              İNŞAAT BİTTİ.<br />
              <span className="text-gold">TEMİZLİK BİZE KALSIN.</span>
            </h2>

            <p className="text-white/80 text-base md:text-lg leading-relaxed mb-6">
              İnşaat ve tadilat sonrası oluşan yoğun toz, cam ve yüzey kalıntıları sıradan bir temizlikten daha fazlasını gerektirir.
            </p>

            <p className="text-white/70 text-base md:text-lg leading-relaxed mb-8">
              Alanınızı videodan değerlendirelim, yapılacak işe uygun profesyonel ekip ve ekipman planlamasını oluşturalım.
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-8">
              {trustPoints.map((point) => (
                <div key={point} className="flex items-center gap-2 text-white/80 text-sm">
                  <i className="ri-check-line text-gold"></i>
                  {point}
                </div>
              ))}
            </div>

            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 bg-gold hover:bg-gold-dark text-navy-dark font-bold text-base rounded-md transition-colors"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              İnşaat Sonrası Teklif Al
            </a>
          </div>

          <div className="hidden lg:block">
            <img
              src="https://readdy.ai/api/search-image?query=Before%20and%20after%20construction%20cleaning%20comparison%20in%20luxury%20residential%20interior%2C%20professional%20cleaning%20team%20in%20navy%20uniforms%20working%20on%20polished%20marble%20floors%2C%20large%20windows%20with%20natural%20light%2C%20transformation%20from%20dusty%20to%20spotless%2C%20editorial%20photography&width=800&height=600&seq=post-construction-detail&orientation=landscape"
              alt="İnşaat sonrası temizlik öncesi ve sonrası"
              className="w-full h-auto rounded-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}